import type {FC} from 'react';
import {Bar, Container, Fill, NumberText, ProgressWrap, Row, Small} from '../types/DiskUsage.styled.ts';
import {formatBytes} from '../../../utils/FileDownLoadUtil.ts';
import useYTdownloadStore from '../../../store/useYTdownloadStore.ts';

const DiskUsage: FC = () => {
    const {diskUsage} = useYTdownloadStore();
    const safeTotal = diskUsage.total > 0 ? diskUsage.total : 1;
    const safeFree = Math.max(0, Math.min(diskUsage.free, safeTotal));
    const used = safeTotal - safeFree;
    const percent = Math.round((used / safeTotal) * 100);

    return (
        <Container>
            <Row>
                <div style={{display: 'inline-flex', textAlign: 'right'}}>
                    <NumberText>
                        {formatBytes(used)} / {formatBytes(diskUsage.total)}
                    </NumberText>
                    <Small>({percent}% 사용됨)</Small>
                </div>
            </Row>
            <ProgressWrap>
                <Bar aria-hidden>
                    <Fill $percent={percent} />
                </Bar>
            </ProgressWrap>
        </Container>
    );
};

export default DiskUsage;
